import { Link } from 'gatsby'
import React, { useState, useEffect } from 'react'
import { LinkedinShareButton, FacebookShareButton, TwitterShareButton } from 'react-share'

import { MarkdownComponent, CustomLink, StrongComponent } from '@/components'
import { htmlToMarkdownConverter } from '@/helpers'
import { ArrowBackIconComponent, FacebookIconComponent, TwitterIconComponent, LinkedinIconComponent } from '@/icons'
import { Label, Heading, ButtonPrimmary } from '@/uikit'
import { JobsSidebar } from '@/partials/jobsSidebar'

const windowGlobal = typeof window !== 'undefined' && window

const StrongAsHeader = ({ children }) => <strong className="font-ilisarniq font-inter font-semibold text-black-lighter dark:text-text-dm leading-normal text-lg my-7.5 md:px-0 dark:text-text-70-dm">{ children }</strong>

interface Props {
    pageContext: {
        id: number
        title: string
        updated_at: Date
        location: string
        locale: string
        departments: string[]
        content: string
        absolute_url: string
    }
}

const JobOfferPage: React.FC<Props> = ({ pageContext }) => {
    const [currentURL, setCurrentUrl] = useState('')
    const { title, content, updated_at, absolute_url, location: { name: locale } } = pageContext || {}
    const convertedContent = htmlToMarkdownConverter(content)
    const applyUrl = `${absolute_url}#application`
    const location = windowGlobal ? windowGlobal.location : undefined

    useEffect(() => {
        if (location) {
            setCurrentUrl(location.href)
        }
    }, [location?.href])

    return (
        <main>
            <div className="px-7.5 md:px-95 lg:px-110 xl:px-175 flex justify-center">
                <div className="max-w-1090 w-full">
                    <div>
                        <div className="mt-17">
                            <Label>JOIN AS</Label>
                        </div>
                        <div className="mb-7.5 relative">
                            <Link to="/careers" className="absolute -left-15 top-4 hidden md:block">
                                <ArrowBackIconComponent />
                            </Link>
                            <div className="dark:text-gray-darker">
                                <Heading>{title}</Heading>
                            </div>
                        </div>
                        <p className="mb-7.5 dark:text-text-dm font-inter font-light text-base not-italic">
                            {updated_at}
                        </p>
                    </div>
                    <div className="flex justify-between max-w-1090 md:pb-210">
                        <div className="max-w-770 w-full md:mr-7.5 md:p-10 md:pb-0 lg:p-20 lg:pb-0 pb-0 md:bg-white md:dark:bg-body-bg1-dm rounded-2xl">
                            <div>
                                <MarkdownComponent
                                    externalComponents={{
                                        strong: {
                                            component: StrongComponent,
                                            props: {
                                                className: 'font-ilisarniq',
                                            },
                                        },
                                    }}
                                >
                                    {convertedContent}
                                </MarkdownComponent>
                            </div>
                            <div className="mt-7.5 border-t dark:border-t border-text-80 border-opacity-20 dark:border-white-clear dark:border-opacity-20 pt-5.4 pb-7.5 flex justify-between">
                                <p className="border-none bg-none font-ilisarniq text-opacity-80 text-text dark:text-white-clear text-xs font-semibold leading-14">
                                    Share
                                </p>
                                <div className="flex w-22 justify-between">
                                    <FacebookShareButton url={currentURL} quote={title}>
                                        <FacebookIconComponent />
                                    </FacebookShareButton>
                                    <TwitterShareButton url={currentURL} title={title}>
                                        <TwitterIconComponent />
                                    </TwitterShareButton>
                                    <LinkedinShareButton url={currentURL} title={title}>
                                        <LinkedinIconComponent />
                                    </LinkedinShareButton>
                                </div>
                            </div>
                        </div>
                        <div className="md:block hidden">
                            <div className="flex flex-col p-7.5 rounded-lg bg-blue-darker dark:bg-body-bg1-dm w-96 max-w-290">
                                <div className="mb-5">
                                    <p className="font-inter font-semibold text-lg leading-semiBig text-text dark:text-gray-darker">
                                        {title}
                                    </p>
                                    <p className="dark:text-text-70-dm">{locale}</p>
                                </div>
                                <CustomLink className="whitespace-nowrap max-w-150 min-w-0 mx-auto block" url={applyUrl} type="external" newTab>
                                    <ButtonPrimmary>
                                        Apply now
                                    </ButtonPrimmary>
                                </CustomLink>
                            </div>
                            <JobsSidebar />
                        </div>
                    </div>
                </div>
                <div className="fixed bottom-0 md:hidden w-full bg-white dark:bg-body-bg1-dm pb-11 px-7.5 pt-4 z-50">
                    <CustomLink url={applyUrl} type="external" newTab>
                        <div className="flex justify-center">
                            <ButtonPrimmary>Apply now</ButtonPrimmary>
                        </div>
                    </CustomLink>
                </div>
            </div>
        </main>
    )
}

export default JobOfferPage
